module.exports = __webpack_public_path__ + "static/media/linkedin.ad51bdff.svg";